module.exports = __webpack_public_path__ + "static/media/logo2.3833d56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo2.png
// module id = 124
// module chunks = 43